import Button from '@algbra/ui/components/Button/Button'
import { Column, Container, Row } from '@algbra/ui/components/Grid/Grid'
import Heading from '@algbra/ui/components/Heading/Heading'
import Whitespace from '@algbra/ui/components/Whitespace/Whitespace'
import { VAlign } from '@algbra/ui/enums/align'
import { graphql, navigate, useStaticQuery } from 'gatsby'
import React from 'react'
import { News } from '../News/News'
import styles from './LatestNews.module.scss'

export type ZoneLatestNewsProps = {
  __typename: 'StrapiGQL_ComponentZonesLatestNews'
  title: string
  id: string
}
export const QUERY_LATESTNEWS = graphql`
  query LatestNewsQuery {
    strapiGQL {
      newsArticles(publicationState: LIVE, sort: "date:desc") {
        ...StrapiGQL_NewsArticlesFragment
        newsImage {
          __typename
          id
          url
          ext
          resolved {
            childImageSharp {
              gatsbyImageData(
                layout: FULL_WIDTH
                formats: WEBP
                webpOptions: { quality: 100 }
                placeholder: DOMINANT_COLOR
              )
            }
          }
        }
      }
    }
  }
`
export default function ZoneLatestNews({ title, id }: ZoneLatestNewsProps) {
  const {
    strapiGQL: { newsArticles },
  } = useStaticQuery(QUERY_LATESTNEWS)
  return (
    <Whitespace className={styles.container} id={id} hasAnimation={false}>
      <Container>
        <Row vAlign={VAlign.TOP} className={styles.title}>
          <Column>
            <Heading type="lg">{title}</Heading>
          </Column>
          <Column auto={true}>
            <Button size="small" onClick={() => navigate('/news')}>
              Browse All
            </Button>
          </Column>
        </Row>
        <News
          itemClassName={styles.itemWrapper}
          list={newsArticles.filter(a => !a.isUnlisted).slice(0, 3)}
          isLatest={true}
        />
      </Container>
    </Whitespace>
  )
}
